import { IndianRupee, Mail, MessageCircle } from "lucide-react";

const donationData = [
  {
    id: 1,
    donor: "Abdul Rahman",
    cause: "Medical Aid",
    category: "Zakat",
    amount: 5000,
    date: "12 Jan 2026",
    receiptEmail: true,
    receiptWhatsApp: true,
  },
  {
    id: 2,
    donor: "Sara Khan",
    cause: "Education Support",
    category: "General",
    amount: 2500,
    date: "13 Jan 2026",
    receiptEmail: true,
    receiptWhatsApp: false,
  },
];

const DonationList = () => {
  return (
    <div className="allcause-page">
      <header className="page-header">
        <h2>Donations</h2>
        <p>All donations received by admin</p>
      </header>

      <div className="allcause-card">
        <table className="allcause-table">
          <thead>
            <tr>
              <th>Donor</th>
              <th>Cause</th>
              <th>Category</th>
              <th>Amount</th>
              <th>Date</th>
              <th>Receipts</th>
            </tr>
          </thead>

          <tbody>
            {donationData.map((donation) => (
              <tr key={donation.id}>
                <td>{donation.donor}</td>
                <td>{donation.cause}</td>
                <td>{donation.category}</td>
                <td className="amount">
                  <IndianRupee size={14} /> {donation.amount}
                </td>
                <td>{donation.date}</td>
                <td className="actions">
                  {donation.receiptEmail && (
                    <span className="icon-chip">
                      <Mail size={14} />
                    </span>
                  )}
                  {donation.receiptWhatsApp && (
                    <span className="icon-chip">
                      <MessageCircle size={14} />
                    </span>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default DonationList;
